// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2L_Vr","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__23jo_"};